import { DateTime } from 'luxon'
import React, { useEffect, useState } from 'react'

const ClockCDMX = ({ isResponsive = false }) => {
    const getCdmxTime = () => {
        return DateTime.now().setZone('America/Mexico_City').toFormat('HH:mm')
    }

    const [time, setTime] = useState(getCdmxTime())

    useEffect(() => {
    const timer = setInterval(() => {
      setTime(getCdmxTime())
    }, 1000)
    return () => clearInterval(timer)
  }, [])
  return (
    <div className={`clock-cdmx ${isResponsive ? 'no-before' : ''} user-info-sidebar-menu-item flex gap-2 align-items-center mt-0 lg:mt-4 mb-0 lg:mb-1`}>
        {!isResponsive && <i className='pi pi-clock text-xl pr-1'/>}
        <span>{!isResponsive && "Hora CDMX: "}{time}</span>
    </div>
  )
}

export default ClockCDMX
